<template>
  <div class="model-content">
    <div
      class="model_67"
      :class="
        posterList.lang == 'ug' || !posterList.lang ? 'model_ug' : 'model_zh'
      "
    >
      <img
        class="img-box"
        :src="posterList.lang == 'ug' || !posterList.lang ? url_ug : url_zh"
      />

      <div class="user-price">
        <span>{{ posterList.amount || 0 }}</span>
      </div>

      <div class="user-rank">
        <img :src="rank_icon" alt="" />
        <span v-if="posterList.lang == 'zh'"> 获得名次 </span>
        <span class="rank-num">{{ posterList.rank || 0 }}</span>
        <span v-if="posterList.lang == 'ug'"> - دەرىجىگە ئېرىشتىڭىز</span>
      </div>

      <div class="user-info">
        <div class="user-avatar">
          <div class="user-image">
            <img :src="posterList.avatar" alt="" />
          </div>
          <div class="user-name">
            <div class="user-name-text">{{ posterList.name }}</div>
            <div class="user-name-addr">{{ posterList.area }}</div>
          </div>
        </div>
        <div class="user-tel">{{ posterList.mobile }}</div>
      </div>

      <div
        class="user-qrcode"
        :class="posterList.lang == 'ug' ? 'qrcode-ug' : 'qrcode-zh'"
      >
        <img :src="posterList.user_qr_code" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "model_67",
  data() {
    return {
      posterList: {},
      url_ug: require("../../img/poster/model_ug_67.png"),
      url_zh: require("../../img/poster/model_zh_67.png"),
      rank_icon: require("../../img/icons/rank-icon.png"),
    };
  },
  created() {
    this.posterList = this.$route.query;
  },
};
</script>

<style scoped>
.model-content {
  width: 391px;
  height: 778px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
}

.model_67 {
  width: 391px;
  height: 778px;
  position: relative;
}

.model_ug {
  direction: rtl;
}

.model_zh {
  direction: ltr;
}

.img-box {
  width: 100%;
  height: 100%;
}

.user-info {
  position: absolute;
  width: 320px;
  height: 38px;
  top: 580px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 10px;
  color: #fff;
  font-size: 14px;
}

.user-info .user-avatar {
  display: flex;
}

.user-info .user-name {
  padding: 0px 8px;
}

.user-info .user-avatar .user-image {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
}

.user-info .user-avatar .user-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info .user-tel {
  direction: ltr;
}

.user-name .user-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 140px;
}

.user-name .user-name-addr {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 140px;
}

.user-price {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 320px;
  height: 38px;
  top: 460px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 34px;
  font-weight: bold;
  color: #fff;
}

.user-rank {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 320px;
  height: 38px;
  top: 516px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  color: #fff;
  border-radius: 14px;
  box-shadow: inset -2px -2px 4px 0px rgba(255, 255, 255, 0.99),
    inset 16px 14px 15px -3px rgba(255, 255, 255, 0.25);
  background: rgba(11, 162, 255, 1);
  line-height: 1em;
}

.user-rank img {
  width: 18px;
  height: 18px;
  margin-bottom: 4px;
}

.user-rank .rank-num {
  color: #e7ff00;
  padding: 0px 6px;
}

.user-qrcode {
  position: absolute;
  height: 100px;
  width: 100px;
  border-radius: 10px;
  overflow: hidden;
}

.user-qrcode.qrcode-ug {
  bottom: 28px;
  right: 13px;
}

.user-qrcode.qrcode-zh {
  bottom: 18px;
  left: 21px;
}

.user-qrcode img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
